import { useRole } from '../../lib/role.tsx';
import { UserSettingsSubscreen } from './UserSettingsSubscreen.js';
import { AdminSettingsSubscreen } from './AdminSettingsSubscreen.js';

export function SettingsLanding() {
  const role = useRole();

  return (
    <div data-testid="settings-landing" className="p-4 space-y-6 max-w-2xl">
      <h1 className="text-xl font-bold">Настройки</h1>
      <section>
        <h2 className="text-base font-semibold mb-3">Внешний вид</h2>
        <UserSettingsSubscreen />
      </section>
      {role === 'management' && (
        <section>
          <h2 className="text-base font-semibold mb-3">Администрирование</h2>
          <AdminSettingsSubscreen />
        </section>
      )}
    </div>
  );
}
